var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMesero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1758D;}\n\t.st1{fill:#F9F9F9;}\n\t.st2{fill:#262626;}\n\t.st3{fill:#72C476;}\n\t.st4{fill:#F14950;}\n\t.st5{fill:#FF8B6E;}\n\t.st6{fill:#569359;}\n\t.st7{fill:#E8EFAF;}\n\t.st8{fill:#FFDEB7;}\n\t.st9{fill:#FBD2A0;}\n\t.st10{fill:#8F4118;}\n\t.st11{fill:#BF5620;}\n\t.st12{fill:#F7F5EB;}\n\t.st13{fill:#E7DEBD;}\n\t.st14{fill:#EBE6CC;}\n\t.st15{fill:#FFE5BA;}\n\t.st16{fill:#414042;}\n\t.st17{fill:#F1F2F2;}\n\t.st18{fill:#333333;}\n\t.st19{fill:#E3F2F3;}\n\t.st20{fill:#575757;}\n\t.st21{fill:#B9C4C4;}\n\t.st22{fill:#131313;}\n\t.st23{fill:#F46D73;}\n\t.st24{fill:#FFFFFF;stroke:#141414;stroke-miterlimit:10;}\n\t.st25{fill:#FDB5AC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -47.6059 94.1452)",
    className: "st0",
    cx: 89.8,
    cy: 104.5,
    rx: 87.3,
    ry: 87.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.4,129.8c16.6-10.3,17.1-28.4,17.2-38.1c-0.2,0-0.9,0-4.5,0c-3.6,0-5.4,0-5.4,0 c-0.3,1,2.4,19.6-13.6,27.3c-10.2,4.9-17.1-1.8-20.1-4.2c0.1,11.4,1.9,23.1,1.9,23.1C120.8,137.1,132.9,135,141.4,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,146.8c12.9,0,15.5-31.9,15.7-35.9c-5.8-2.2-12.3-4.6-12.3-4.6s-1.2,1.6-4.6,1.6c-3.5,0-4.6-1.2-4.6-1.2 s-4.8,1.9-11.7,4.5l1.7-0.7C74.2,110.5,76.2,146.8,90,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,183.1l-12.1,7.3l-5.6-0.2C78,191.3,83.9,192,90,192c5.6,0,11.2-0.6,16.5-1.6h-4.3L90,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.8,137.9l0,5C116.8,139.8,116.8,137.9,116.8,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.7,124c-30.7,35.4-0.9,57.2-0.9,57.2s0.3-0.3,0.6-0.8c1.1-1.3,3.2-4.1,3.8-6c0.1-0.3,0.1-0.5,0.2-0.8 c0,0-19.5-11.8-0.7-29.8c2.8-2.6,4.7-4.4,4.7-4.4S65,125.7,65,114C63.8,114.5,58.5,120.7,55.7,124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90,183.1v-36.3c-13.8,0-15.7-36.3-15.7-36.3l-1.7,0.7L65,114c0,11.7-1.8,25.5-1.8,25.5l0,48.3 c2.9,0.9,6,1.7,9,2.4l5.6,0.2L90,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.8,137.9c0,0-1.8-11.6-1.9-23.1c0-0.3,0-0.6,0-0.9l-9.2-3.5c0,0,0,0.1,0,0.4c-0.3,4-2.8,35.9-15.7,35.9 v36.3l12.2,7.3h4.3c3.6-0.7,7.1-1.6,10.6-2.7l-0.2-44.8L116.8,137.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.6,66.4c0,0-5.2-9.2,0.2-14.4c5.5-5.2,6.9-9.4,6.9-9.4s6.7,11.4,4.8,17C188.5,65.2,178.6,66.4,178.6,66.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.5,69c0,0-11.3-1.9-11.3-9.7c0-7.9-2.2-10.9-2.2-10.9s8.7,1.8,12.5,9.1C147.4,64.8,145.3,66,144.5,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.9,69c0,0-11.3-1.9-11.3-9.7c0-7.9-2.2-10.9-2.2-10.9s8.7,1.8,12.5,9.1C158.8,64.8,156.7,66,155.9,69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M172.5,35.6c3.3-4.4,2.3-10.6-2.1-13.8l-11.8,15.9C163,40.9,169.2,40,172.5,35.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.7,35c2.9-3.9,2.1-9.5-1.8-12.5l-10.6,14.3C163.2,39.8,168.8,39,171.7,35z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.6,33.9c0.5,0.4,0.6,0.6,0.4,0.8c-0.1,0.2-0.4,0.2-0.8-0.2c-0.5-0.4-0.9-1.1-0.9-1.1 S170.1,33.5,170.6,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.6,31.5c0.6,0.2,0.7,0.4,0.7,0.6c-0.1,0.2-0.3,0.3-0.9,0.1c-0.6-0.2-1.2-0.7-1.2-0.7 S171,31.4,171.6,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.7,29c0.6,0,0.8,0.1,0.8,0.3c0,0.2-0.2,0.4-0.8,0.4c-0.6,0-1.4-0.3-1.4-0.3S171.1,29,171.7,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171,26.5c0.5-0.2,0.8-0.2,0.9,0c0.1,0.2,0,0.4-0.6,0.6c-0.5,0.2-1.4,0.2-1.4,0.2S170.4,26.8,171,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M169.4,24.5c0.4-0.4,0.7-0.5,0.8-0.3c0.1,0.1,0.1,0.4-0.3,0.8c-0.4,0.4-1.2,0.7-1.2,0.7S169,24.9,169.4,24.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.9,36.5c0.3,0.5,0.6,0.6,0.7,0.5c0.2-0.1,0.2-0.4-0.1-0.9c-0.3-0.5-1-0.9-1-0.9S167.6,36,167.9,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.5,37.3c0.1,0.6,0.3,0.8,0.5,0.7c0.2,0,0.3-0.3,0.2-0.8c-0.1-0.6-0.6-1.2-0.6-1.2S165.4,36.8,165.5,37.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163,37.3c-0.1,0.6,0.1,0.8,0.3,0.9c0.2,0,0.4-0.2,0.4-0.7c0.1-0.6-0.2-1.4-0.2-1.4S163,36.7,163,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M160.6,36.4c-0.3,0.5-0.2,0.8-0.1,0.9c0.2,0.1,0.4,0,0.7-0.5c0.3-0.5,0.3-1.4,0.3-1.4S160.8,35.9,160.6,36.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.9,31.4c0.4,0.3,0.5,0.5,0.4,0.6c-0.1,0.1-0.3,0.1-0.7-0.2c-0.4-0.3-0.7-0.9-0.7-0.9 S166.5,31.1,166.9,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.7,29.4c0.5,0.1,0.6,0.3,0.6,0.5c-0.1,0.2-0.3,0.2-0.7,0.1c-0.5-0.1-1-0.6-1-0.6S167.2,29.3,167.7,29.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.8,27.3c0.5,0,0.7,0.1,0.7,0.3c0,0.2-0.2,0.3-0.6,0.3c-0.5,0-1.1-0.2-1.1-0.2S167.3,27.3,167.8,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.7,33.6c0.3,0.4,0.5,0.5,0.6,0.4c0.1-0.1,0.2-0.3-0.1-0.7c-0.3-0.4-0.9-0.8-0.9-0.8 S164.4,33.2,164.7,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.6,34.3c0.1,0.5,0.3,0.6,0.4,0.6c0.2,0,0.3-0.2,0.1-0.7c-0.1-0.5-0.5-1-0.5-1S162.5,33.8,162.6,34.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.4,45.3c4,4.8,11.1,5.5,15.9,1.5l-14.4-17.4C138.1,33.4,137.4,40.5,141.4,45.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.2,44.6c3.6,4.3,10,4.9,14.3,1.4l-12.9-15.7C139.3,33.9,138.7,40.3,142.2,44.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.8,43.7c-0.5,0.4-0.8,0.5-1,0.3c-0.1-0.2-0.1-0.5,0.4-0.9c0.5-0.4,1.4-0.7,1.4-0.7 S144.3,43.3,143.8,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.1,45.4c-0.3,0.6-0.6,0.7-0.8,0.6c-0.2-0.1-0.2-0.4,0.1-1c0.3-0.6,1.1-1.1,1.1-1.1 S146.4,44.9,146.1,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M148.9,46.3c-0.1,0.7-0.3,0.9-0.6,0.9c-0.2,0-0.4-0.3-0.2-1c0.1-0.7,0.7-1.4,0.7-1.4S149,45.6,148.9,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.8,46.1c0.1,0.7,0,1-0.2,1c-0.2,0-0.4-0.2-0.6-0.8c-0.1-0.7,0.1-1.6,0.1-1.6S151.7,45.5,151.8,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M154.5,45c0.3,0.6,0.3,0.9,0.1,1c-0.2,0.1-0.5,0-0.8-0.6c-0.3-0.6-0.4-1.5-0.4-1.5S154.1,44.4,154.5,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.6,40c-0.6,0.2-0.8,0.5-0.8,0.7c0.1,0.2,0.4,0.3,1,0.1c0.6-0.2,1.3-0.9,1.3-0.9S142.3,39.8,141.6,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.3,37.2c-0.7,0-0.9,0.2-0.9,0.4c0,0.2,0.2,0.4,0.9,0.4c0.7,0,1.5-0.4,1.5-0.4S142,37.2,141.3,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.1,34.3c-0.6-0.2-0.9-0.2-1,0.1c-0.1,0.2,0.1,0.5,0.7,0.7c0.6,0.2,1.6,0.2,1.6,0.2 S142.7,34.6,142.1,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.7,31.9c-0.5-0.4-0.8-0.5-1-0.3c-0.2,0.2-0.1,0.5,0.4,0.9c0.5,0.4,1.4,0.7,1.4,0.7 S144.2,32.4,143.7,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147.5,40.3c-0.4,0.4-0.7,0.4-0.8,0.2c-0.1-0.2-0.1-0.4,0.4-0.7c0.4-0.4,1.2-0.6,1.2-0.6 S148,39.9,147.5,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.5,41.7c-0.3,0.5-0.5,0.6-0.7,0.5c-0.2-0.1-0.2-0.3,0.1-0.8c0.3-0.5,0.9-0.9,0.9-0.9 S149.8,41.2,149.5,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.8,42.4c-0.1,0.6-0.3,0.8-0.5,0.7c-0.2,0-0.3-0.3-0.2-0.8c0.1-0.5,0.6-1.2,0.6-1.2 S151.9,41.9,151.8,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.7,37.2c-0.5,0.2-0.7,0.4-0.6,0.6c0.1,0.2,0.3,0.3,0.8,0.1c0.5-0.2,1.1-0.7,1.1-0.7S146.3,37,145.7,37.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.5,34.8c-0.6,0-0.8,0.1-0.8,0.3c0,0.2,0.2,0.3,0.8,0.3c0.6,0,1.3-0.3,1.3-0.3S146,34.8,145.5,34.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.6,24.4c0,4.1-3.3,7.4-7.4,7.4c-4.1,0-7.4-3.3-7.4-7.4c0-4.1,3.3-7.4,7.4-7.4 C189.3,17,192.6,20.3,192.6,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.8,24.4c0,3.7-3,6.6-6.6,6.6c-3.7,0-6.6-3-6.6-6.6c0-3.7,3-6.6,6.6-6.6 C188.9,17.8,191.8,20.7,191.8,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190,24.4c0,2.6-2.1,4.8-4.8,4.8c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.1-4.8,4.8-4.8 C187.8,19.6,190,21.8,190,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.6,27.6c-0.1,0.8-0.6,1.1-1.1,1c-0.5-0.1-0.9-0.5-0.7-1.3c0.1-0.8,1.3-1.7,1.3-1.7 S185.8,26.8,185.6,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.9,26.1c0.5,0.6,0.4,1.2,0,1.5c-0.4,0.3-0.9,0.4-1.5-0.3c-0.5-0.6-0.5-2.1-0.5-2.1 S187.4,25.5,187.9,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M188.3,23.4c0.8,0,1.2,0.4,1.2,1c0,0.5-0.3,0.9-1.1,0.9c-0.8,0-1.9-0.9-1.9-0.9S187.5,23.4,188.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.4,21.4c0.5-0.6,1.1-0.6,1.5-0.3c0.4,0.3,0.5,0.8,0,1.5c-0.5,0.6-1.9,0.9-1.9,0.9S185.9,22,186.4,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.7,21.5c-0.1-0.8,0.2-1.2,0.7-1.3c0.5-0.1,1,0.1,1.1,1c0.2,0.8-0.6,2.1-0.6,2.1S183.8,22.3,183.7,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182,23.7c-0.7-0.4-0.8-1-0.6-1.4c0.3-0.5,0.7-0.7,1.5-0.2c0.7,0.4,1.2,1.8,1.2,1.8S182.7,24.1,182,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182.6,26.4c-0.8,0.3-1.3,0-1.5-0.5c-0.2-0.5,0-1,0.7-1.3c0.8-0.3,2.1,0.2,2.1,0.2S183.4,26.1,182.6,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186,24.4c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8C185.6,23.6,186,24,186,24.4z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.5,51.9c-1-1.2-3.8-0.7-6.3,1.2c-1.1,0.8-1.9,1.8-2.4,2.7c0.5,0.5,1,1.1,1.5,1.7L187.5,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.3,57.5c0.5,0.6,0.9,1.2,1.2,1.9c1-0.3,2.1-0.9,3.2-1.7c2.5-1.9,3.8-4.5,2.8-5.7l0,0L180.3,57.5 L180.3,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M180.3,57.5l-7,5.4l0,0c1.1,1.5,2.8,2.4,4.5,2.6c1.7,0.2,3.5-0.2,4.9-1.3c0.1-0.1,0.2-0.1,0.3-0.2 c0-1.3-0.5-2.9-1.5-4.5C181.1,58.7,180.7,58.1,180.3,57.5L180.3,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M174.5,53.4c-1.5,1.1-2.3,2.7-2.6,4.4c-0.2,1.7,0.2,3.5,1.3,5l7-5.4c-0.5-0.6-1-1.2-1.5-1.7 c-1.4-1.3-2.8-2.2-4-2.6C174.7,53.3,174.6,53.4,174.5,53.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M181.8,34.1c-1.1-0.6-3.1,0.7-4.3,3c-0.5,1-0.9,2-1,2.8c0.5,0.2,1.1,0.5,1.7,0.8L181.8,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M178.2,40.7c0.6,0.3,1.1,0.6,1.5,1c0.7-0.6,1.3-1.4,1.9-2.3c1.2-2.3,1.3-4.6,0.2-5.2l0,0L178.2,40.7 L178.2,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M178.2,40.7l-3.5,6.4l0,0c1.3,0.7,2.9,0.9,4.2,0.4c1.3-0.4,2.6-1.3,3.3-2.6c0-0.1,0.1-0.2,0.1-0.3 c-0.4-1-1.4-2-2.6-2.9C179.3,41.3,178.8,41,178.2,40.7L178.2,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M172.5,39.5c-0.7,1.3-0.8,2.8-0.5,4.2c0.4,1.4,1.3,2.6,2.7,3.3l3.5-6.4c-0.5-0.3-1.1-0.5-1.7-0.8 c-1.5-0.5-2.8-0.8-3.9-0.6C172.6,39.4,172.6,39.5,172.5,39.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M154.9,11.4c0,0.3,0,0.6,0.1,0.9c0.2,1.5,0.7,2.9,1.3,4c0.8-0.2,1.7-0.4,2.6-0.5l-0.6-4.8L154.9,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M158.9,15.7c0.9-0.1,1.8-0.2,2.7-0.2c0.3-1.2,0.4-2.6,0.2-4.2c0-0.3-0.1-0.6-0.2-0.8l-3.4,0.4L158.9,15.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M151.2,19.2c0.3,2.1,1.4,3.9,3.1,5.1c1.6,1.2,3.8,1.8,6,1.5l-1.3-10.1c-0.9,0.1-1.8,0.3-2.6,0.5 c-2.2,0.6-4,0.6-5.2,1.7C151.1,18.1,151.2,19.1,151.2,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M158.9,15.7l1.3,10.1l0,0c2.2-0.3,4.1-1.4,5.4-3c1.3-1.6,1.9-3.6,1.6-5.7c0-0.1-0.5-1.8-0.5-1.9 c-1.3-0.7-3.1-0.5-5.3,0C160.2,15.4,159.8,15.6,158.9,15.7L158.9,15.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M171.7,54c0,3.7-3,6.7-6.8,6.7c-3.7,0-6.8-3-6.8-6.7c0-3.7,3-6.8,6.8-6.8C168.6,47.2,171.7,50.3,171.7,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171,54c0,3.3-2.7,6-6,6c-3.3,0-6.1-2.7-6.1-6c0-3.3,2.7-6.1,6.1-6.1C168.3,47.9,171,50.6,171,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.3,54c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4C167.3,49.6,169.3,51.6,169.3,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.3,56.9c-0.1,0.8-0.6,1-1,0.9c-0.5-0.1-0.8-0.4-0.7-1.2c0.1-0.8,1.1-1.6,1.1-1.6S165.4,56.2,165.3,56.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.4,55.6c0.5,0.6,0.4,1.1,0,1.4c-0.4,0.3-0.8,0.3-1.3-0.2c-0.5-0.6-0.5-1.9-0.5-1.9S166.9,55,167.4,55.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.7,53.1c0.8,0,1.1,0.4,1.1,0.9c0,0.5-0.3,0.9-1,0.9c-0.8,0-1.8-0.8-1.8-0.8S167,53.1,167.7,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166,51.2c0.5-0.6,1-0.6,1.4-0.3c0.4,0.3,0.5,0.8,0,1.3c-0.5,0.6-1.8,0.8-1.8,0.8S165.6,51.8,166,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163.5,51.4c-0.1-0.7,0.2-1.1,0.7-1.2c0.5-0.1,0.9,0.1,1,0.9c0.1,0.8-0.5,1.9-0.5,1.9S163.7,52.1,163.5,51.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162,53.3c-0.7-0.4-0.7-0.9-0.5-1.3c0.2-0.4,0.7-0.6,1.3-0.2c0.7,0.4,1.1,1.6,1.1,1.6S162.7,53.7,162,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.6,55.8c-0.7,0.3-1.2,0-1.3-0.5c-0.2-0.4,0-0.9,0.7-1.2c0.7-0.3,1.9,0.2,1.9,0.2S163.3,55.5,162.6,55.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.6,54c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 C165.3,53.3,165.6,53.6,165.6,54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.5,81.2h15.1c8.1,0,15.3-4.2,19.4-10.6h-53.8C140.3,77,147.4,81.2,155.5,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.9,65.9c0.3,1,0.8,1.9,1.2,2.8h56c0.5-0.9,0.9-1.9,1.2-2.8H133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.7,58.2h-61.2c0,2,0.3,4,0.8,5.9h59.6C193.4,62.2,193.7,60.2,193.7,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.9,64.1h-59.6c0.2,0.6,0.4,1.2,0.6,1.8h58.4C192.5,65.3,192.7,64.7,192.9,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.2,70.6H190c0.4-0.6,0.7-1.2,1.1-1.8h-56C135.4,69.4,135.8,70,136.2,70.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M154.5,30.4c0,2.5-2,4.6-4.6,4.6v1.8c3.5,0,6.3-2.8,6.3-6.3c0-3.5-2.8-6.3-6.3-6.3v1.8 C152.4,25.9,154.5,27.9,154.5,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M145.4,30.4c0,2.5,2,4.6,4.6,4.6v1.8c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3v1.8 C147.4,25.9,145.4,27.9,145.4,30.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M178.4,13.6c0,2.2-1.8,4-4,4v1.5c3.1,0,5.6-2.5,5.6-5.6c0-3.1-2.5-5.6-5.6-5.6v1.6 C176.7,9.6,178.4,11.4,178.4,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M170.4,13.6c0,2.2,1.8,4,4,4v1.5c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6v1.6 C172.2,9.6,170.4,11.4,170.4,13.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M159.4,45.5c0,2.2-1.8,4-4,4v1.5c3.1,0,5.6-2.5,5.6-5.6c0-3.1-2.5-5.6-5.6-5.6v1.6 C157.6,41.5,159.4,43.3,159.4,45.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.3,57.4c0,8.2,0,45.4,0,45.4c-2.5,0-32.2,0-32.2,0s0.6-44.2-0.2-43.9V27.4C106.8,27.4,121.4,36,121.3,57.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.5,57.4c0,8.2,0,45.4,0,45.4c2.5,0,32.2,0,32.2,0S88,58.5,88.9,58.9V27.4C71,27.4,56.4,36,56.5,57.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M119,73.2c0,14.6-12.6,27.2-29.7,27.2c-17,0-30.8-11.8-30.8-26.4c0-38.1,13.2-37.3,30.2-37.3 C105.8,36.8,119,39,119,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.8,69.3c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 C81.4,66.1,82.8,67.5,82.8,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M81.3,68.5c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 C80.8,67.2,81.3,67.8,81.3,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M95.9,69.3c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1 C97.3,66.1,95.9,67.5,95.9,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M97.4,68.5c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3S97.4,67.8,97.4,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M64.4,80.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2C62.5,76,64.4,77.9,64.4,80.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M114.3,80.2c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.2-4.2-4.2 C116.2,76,114.3,77.9,114.3,80.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M78.5,59.2c-2.9,0-5.5,1-6.7,2.5c0,0,3.2-1.7,6.7-1.7c3.7,0,6.7,1.7,6.7,1.7C83.9,60.2,81.4,59.2,78.5,59.2z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M99.7,59.2c2.9,0,5.5,1,6.7,2.5c0,0-3.1-1.7-6.7-1.7C96,60,93,61.7,93,61.7C94.3,60.2,96.8,59.2,99.7,59.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 99.3,
    className: "st15",
    width: 9.2,
    height: 8.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M197.5,85c0,0.8-0.6,1.4-1.4,1.4h-65.5c-0.8,0-1.4-0.6-1.4-1.4l0,0c0-0.8,0.6-1.4,1.4-1.4h65.5 C196.9,83.5,197.5,84.2,197.5,85L197.5,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M154.9,92.2L154.9,92.2C155,92.2,154.9,92.2,154.9,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M148.7,91.7c0,0-7.2-1.3-6.8-3.2c0.5-2.6,7.3,0.5,10,0.5c1.8,0,19.7-1.5,19.7,1.1c0,1.8-6.1,1.7-13,1.7H148.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M95.8,135.8c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2C94.9,133.8,95.8,134.7,95.8,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M95.8,124.5c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2C94.9,122.5,95.8,123.4,95.8,124.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.3,113.2c1.6-0.5,0.9-5.7,0.9-5.7s0.7-5.2-0.9-5.7c-1.6-0.5-10.6,5.7-10.6,5.7S97.7,113.7,99.3,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.2,113.1c1.6,0.5,10.6-5.6,10.6-5.6s-9-6.2-10.6-5.7c-1.6,0.5-0.9,5.7-0.9,5.7S76.6,112.7,78.2,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.3,108.9l1.5,0h1.5c0,0,0.5-1.1,0-2.8h-1.5l-1.5,0C86.7,107.8,87.3,108.9,87.3,108.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M63.6,177.9c-1-1-2.5-2.2-4.5-3.6c-0.6,2-2.7,4.7-3.8,6l-0.2,0.4c0,0,1.7,1.6,4,3.2c2,1.3,4.4,2.4,5.6,1.1 C67.5,182.2,65,179.4,63.6,177.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 109,
    className: "st21",
    width: 1.2,
    height: 37.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "87.3,184.7 90,183.1 90,146.8 87.5,146.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M97.8,169.4c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1.1,0.9-2,2-2S97.8,168.3,97.8,169.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M97.8,158.1c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1.1,0.9-2,2-2S97.8,157,97.8,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M79.6,102.9c-0.8-0.3-2-0.2-1.4,1.1c0.5,1.3,8.5,2.8,8.5,2.8S83.5,104.2,79.6,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M97.9,102.9c0.8-0.3,2-0.2,1.4,1.1c-0.5,1.3-8.5,2.8-8.5,2.8S94.1,104.2,97.9,102.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119,57.8 81.3,57.8 78.8,42.6 74.7,57.8 57.4,57.8 60.8,44.6 68.3,38 88.9,33.9 113.1,36.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M88.9,92.9c6.7,0,9.4-5.8,9.4-10.9H79.5C79.5,87.1,82.5,92.9,88.9,92.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M112.9,80.2c0,2.3-2.5,4.2-5.6,4.2c-3.1,0-5.6-1.9-5.6-4.2c0-2.3,2.5-4.2,5.6-4.2 C110.4,76,112.9,77.9,112.9,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M64.9,80.2c0,2.3,2.5,4.2,5.6,4.2c3.1,0,5.6-1.9,5.6-4.2c0-2.3-2.5-4.2-5.6-4.2C67.4,76,64.9,77.9,64.9,80.2z "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesero);
export default __webpack_public_path__ + "static/media/mesero.07f511cafdc987261030046ba0d19e0f.svg";
export { ForwardRef as ReactComponent };